var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTerms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8337 42.6435H57.167V49.7268H28.8337V42.6435ZM35.917 70.9768H21.7503V14.3101H46.542V32.0185H64.2503V42.9976L71.3337 35.9143V28.4768L50.0837 7.22681H21.7503C19.8717 7.22681 18.07 7.97308 16.7417 9.30147C15.4133 10.6298 14.667 12.4315 14.667 14.3101V70.9768C14.667 72.8554 15.4133 74.6571 16.7417 75.9855C18.07 77.3139 19.8717 78.0601 21.7503 78.0601H35.917V70.9768ZM28.8337 63.8935H43.3545L46.542 60.706V56.8101H28.8337V63.8935ZM72.042 46.1851C72.3962 46.1851 73.1045 46.5393 73.4587 46.8935L78.0628 51.4976C78.7712 52.206 78.7712 53.6226 78.0628 54.331L74.5212 57.8726L67.0837 50.4351L70.6253 46.8935C70.9795 46.5393 71.3337 46.1851 72.042 46.1851ZM72.042 59.9976L50.4378 81.6018H43.0003V74.1643L64.6045 52.5601L72.042 59.9976Z",
    fill: "url(#paint0_linear_11568_10873)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11568_10873",
    x1: 46.6305,
    y1: 7.22681,
    x2: 46.6305,
    y2: 100.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E57E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D150E3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.1209d049d17599b277a55b08c8a3a2b5.svg";
export { ForwardRef as ReactComponent };